import Decimal from 'decimal.js';

export enum TransferInterestPattern {
  /**
   * 銘柄の譲渡金利による (一律)
   */
  SymbolInterest = 1,
  /**
   * 申込金額による (通常)
   */
  Amount = 2,
}

const matchInterestRate = (
  interestPattern: TransferInterestPattern,
  amount: number,
  symbolInterestRate: number | null | undefined,
  boundaryAmount: number,
  lowerRate: number,
  upperRate: number,
): number => {
  switch (interestPattern) {
    case TransferInterestPattern.SymbolInterest:
      return symbolInterestRate!;
    case TransferInterestPattern.Amount:
      if (amount >= boundaryAmount) {
        return upperRate;
      } else {
        return lowerRate;
      }
  }
};

const dateDiffDays = (startDate: Date, endDate: Date) => {
  return Math.floor((endDate.getTime() - startDate.getTime()) / (24 * 3600 * 1000));
};

export const calcInterest = (
  amount: number,
  transferDate: Date,
  leaseStartDate: Date,
  interestPattern: TransferInterestPattern,
  symbolInterestRate: number | null | undefined,
  boundaryAmount: number,
  lowerRate: number,
  upperRate: number,
): number => {
  // マイナスの場合もあり
  return new Decimal(amount)
    .mul(
      new Decimal(matchInterestRate(interestPattern, amount, symbolInterestRate, boundaryAmount, lowerRate, upperRate)),
    )
    .mul(new Decimal(dateDiffDays(leaseStartDate, transferDate)))
    .div(new Decimal(365))
    .floor()
    .toNumber();
};
